import React from 'react';
import { Button, Space } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { Setter } from './Setter';

interface ArraySetterProps {
  value: any; // 从 any[] 改为 any，因为现在可能是对象
  onChange: (value: any) => void;
  config: {
      name: string;
      setter: string; // 指定子项 setter 类型
      items?: any;   // 子项 setter 的items
  }[];
}

const ArrayContainer = styled.div`
  padding: 8px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
`;

const ItemContainer = styled.div`
  margin-bottom: 8px;
  padding: 8px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  position: relative;
`;

export const ArraySetter: React.FC<ArraySetterProps> = ({ value = {}, onChange, config }) => {
  const handleAdd = () => {
    const newValue = { ...value };
    config?.forEach(itemConfig => {
      newValue[itemConfig.name] = itemConfig.setter === 'select' ? 
        (itemConfig.options?.[0]?.value || '') : 
        (itemConfig.setter === 'number' ? 0 : '');
    });
    onChange(newValue);
  };

  const handleDelete = (name: string) => {
    const newValue = { ...value };
    delete newValue[name];
    onChange(newValue);
  };

  const handleItemChange = (name: string, itemValue: any) => {
    const newValue = {
      ...value,
      [name]: itemValue,
    };
    onChange(newValue);
  };

  return (
    <ArrayContainer>
      {config?.map((setterConfig, index) => (
        <ItemContainer key={index}>
          <Space direction="vertical" style={{ width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>{setterConfig.name}</span>
              <Button 
                type="text" 
                icon={<DeleteOutlined />} 
                onClick={() => handleDelete(setterConfig.name)}
              />
            </div>
            <Setter
                key={setterConfig.name}
                config={setterConfig}
                value={value[setterConfig.name]}
                onChange={(newValue) => handleItemChange(setterConfig.name, newValue)}
              />
          </Space>
        </ItemContainer>
      ))}
      <Button
        type="dashed"
        block
        icon={<PlusOutlined />}
        onClick={handleAdd}
      >
        添加项
      </Button>
    </ArrayContainer>
  );
};

export default ArraySetter;